/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import React from "react";
import { Store, useSelector } from "../../store";
import type { ProductData, UserMessage } from "@spwn/types/firebase/firestore";
import { CommentItemPurchasedHiddenName } from "components/streaming/commentItem/CommentItemPurchasedHiddenName";
import { CommentItemSuperChatV2 } from "./CommentItemSuperChatV2";
import { CommentItemNormalV2 } from "./CommentItemNormalV2";
import { Box } from "@material-ui/core";

interface Props {
  eventId: string;
  message: UserMessage;
  isCommentUser: boolean;
  isDarkModeEnabled?: boolean;
  eventGoodsMap: { [key: string]: ProductData };
  giftAmountList: number[];
  onClickBanUser: (comment: Pick<UserMessage, "_id" | "uid">) => Promise<void>;
  onClickBanComment: (idx: string) => Promise<void>;
  msgDeleteFunction: (idx: string) => void;
}

export const StreamingCommentItemV2: React.FC<Props> = (props) => {
  const giftItemMap = useSelector(
    (state: Store) => state.streaming.giftItemMap
  );

  const { isSuperChat, isPurchased, purchasedProductId } = props.message;
  const purchasedProduct: ProductData = isPurchased
    ? // @ts-expect-error TS2538
      props.eventGoodsMap?.[purchasedProductId]
    : null;

  // ギフトと商品購入は同時に行われないので、両方がtrueになることはない
  // 正しくない値のコメントなので、nullを返す
  if (isSuperChat && isPurchased) {
    return null;
  }

  // 自分以外のコメントがBANされた場合は削除されました表示にする
  if (!props.isCommentUser && props.message.isBan) {
    return (
      <Box padding={"4px 12px"} color={"gray"} fontSize={"12px"}>
        このコメントは削除されました
      </Box>
    );
  }

  // スパチャコメントの時の表示
  if (isSuperChat && !isPurchased) {
    const { giftItemId } = props.message;
    const giftItem = giftItemId ? giftItemMap?.[giftItemId] : undefined;

    return (
      <CommentItemSuperChatV2
        userIcon={props.message.icon}
        userName={props.message.name}
        isCommentUser={props.isCommentUser}
        amount={props.message.amount}
        eventId={props.eventId}
        message={props.message}
        backgroundColor={props.message.color}
        options={{
          color: giftItem?.textColor ?? "#fff",
          stickerImageUrl: giftItem && giftItem?.imgUrl,
          backgroundImageUrl: giftItem && giftItem?.bgImgUrl,
        }}
        onClickBanUser={props.onClickBanUser}
        onClickBanComment={props.onClickBanComment}
      />
    );
  }

  // 商品を購入した時の表示
  if (!isSuperChat && isPurchased) {
    return (
      <CommentItemPurchasedHiddenName purchasedProduct={purchasedProduct} />
    );
  }

  // isSuperChatとisPurchasedがfalseの時、通常のコメントの表示する
  return (
    <CommentItemNormalV2
      eventId={props.eventId}
      message={props.message}
      isCommentUser={props.isCommentUser}
      // @ts-expect-error TS2322
      isDarkModeEnabled={props.isDarkModeEnabled}
      onClickBanUser={props.onClickBanUser}
      onClickBanComment={props.onClickBanComment}
      msgDeleteFunction={props.msgDeleteFunction}
    />
  );
};
